import { APPROVAL_CONDITION_CONFIG, APPROVAL_CHANGE_TYPES_CONFIG, EApprovalTriggerChangeTypes, } from '@/api/logical/approval_flow';
import { api } from '@/api/api';
export class ApprovalFlowApiImpl {
    constructor() {
        this.name = 'approvalFlowApiImpl';
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    transformTriggerConditionList(triggerEventName, conditionList) {
        if (!conditionList || conditionList.length === 0) {
            return [];
        }
        return conditionList.map(v => {
            var _a, _b;
            const fieldValue = Array.isArray(v.fieldValues) ? v.fieldValues.join('、') : '';
            const triggerName = triggerEventName ? triggerEventName + ': ' : '';
            const changeTypeName = ((_a = APPROVAL_CHANGE_TYPES_CONFIG[v.changeType]) === null || _a === void 0 ? void 0 : _a.label) || '';
            const conditionName = ((_b = APPROVAL_CONDITION_CONFIG[v.conditionType]) === null || _b === void 0 ? void 0 : _b.label) || '';
            return v.changeType === EApprovalTriggerChangeTypes.when
                ? `${triggerName}${v.fieldName}${changeTypeName}`
                : `${triggerName}${v.fieldName}${changeTypeName}${conditionName}${fieldValue}`;
        });
    }
    async doGetApprovalRecordListPage(params) {
        const url = this.systemApi.getUrl('doGetApprovalRecordListPage');
        const res = await this.httpApi.get(url, params);
        const { success, data, message = '请求错误' } = res.data || {};
        if (success && data) {
            const items = (data.content || []).map((v, index) => ({
                approvalId: v.approvalId,
                recordId: v.recordId,
                bizId: v.bizId,
                bizName: v.bizName,
                index: data.page && data.pageSize ? (data.page - 1) * data.pageSize + index + 1 : 0,
                approvalName: v.approvalName,
                status: v.recordStatus,
                objectType: v.objectType,
                objectName: v.objectName,
                triggerCondition: this.transformTriggerConditionList(v.triggerEventName, v.triggerConditionList),
                createBy: v.createBy,
                createAt: v.createAt,
                triggerEventName: v.triggerEventName,
            }));
            return {
                total: data.totalSize,
                items,
            };
        }
        console.error('approval flow doGetApprovalRecordListPage', message);
        throw message;
    }
    async doModifyApprovalStatus(params) {
        const url = this.systemApi.getUrl('doModifyApprovalStatus');
        const res = await this.httpApi.post(url, Object.assign({}, params), { contentType: 'json' });
        const { success, message = '请求错误' } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow doModifyApprovalStatus', message);
        throw message;
    }
    async doRecallApproval(params) {
        const url = this.systemApi.getUrl('doRecallApproval');
        const res = await this.httpApi.post(url, Object.assign({}, params), { contentType: 'json' });
        const { success, message = '请求错误' } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow doRecallApproval', message);
        throw message;
    }
    async updateApproval(params) {
        const url = this.systemApi.getUrl('updateApproval');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { success, error } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow updateApproval', error);
        throw res.data;
    }
    async approvalAccountList() {
        const url = this.systemApi.getUrl('approvalAccountList');
        const res = await this.httpApi.get(url);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('approval flow approvalAccountList', error);
        throw error;
    }
    async configApproval() {
        const url = this.systemApi.getUrl('configApproval');
        const res = await this.httpApi.get(url);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('approval flow configApproval', error);
        throw error;
    }
    async createApproval(params) {
        const url = this.systemApi.getUrl('createApproval');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { success, error } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow createApproval', error);
        throw res.data;
    }
    async doGetApprovalRecordFlow(params) {
        const url = this.systemApi.getUrl('doGetApprovalRecordFlow');
        const res = await this.httpApi.get(url, params);
        const { success, data, message = '请求错误' } = res.data || {};
        if (success && data) {
            const accNameMap = new Map();
            const flowList = (data.flowList || []).map(v => {
                v.accountInfoList.forEach(item => {
                    if (item) {
                        const { accId, accName } = item;
                        if (!accNameMap.get(accId)) {
                            accNameMap.set(accId, accName);
                        }
                    }
                });
                const remarkList = (v.remarksList || []).map(it => ({
                    accId: it.accId,
                    accName: accNameMap.get(it.accId) || '-',
                    remarks: it.remarks,
                }));
                return Object.assign(Object.assign({}, v), { remarkList });
            });
            return {
                approvalId: data.approvalId,
                hasRecord: data.hasRecord,
                objectName: data.objectName,
                bizId: data.bizId,
                objectType: data.objectType,
                recordId: data.recordId,
                createByMe: data.createByMe,
                waitByMe: data.waitByMe,
                bizName: data.bizName,
                recordStatus: data.recordStatus,
                flowList,
            };
        }
        console.error('approval flow doGetApprovalRecordFlow', message);
        throw message;
    }
    async doGetApprovalLogList(params) {
        const url = this.systemApi.getUrl('doGetApprovalLogList');
        const res = await this.httpApi.get(url, params);
        const { success, data, message = '请求错误' } = res.data || {};
        if (success && (data === null || data === void 0 ? void 0 : data.content)) {
            const list = data.content.map(v => ({
                historyId: v.logId,
                remark: v.remark,
                time: v.updateAt,
                accountInfo: v.accountInfo,
                status: v.status,
            }));
            return {
                list,
                approvalName: data.approvalName,
            };
        }
        console.error('approval flow getApprovalProcess', message);
        throw message;
    }
    async getApprovalList(params) {
        const url = this.systemApi.getUrl('getApprovalList');
        const res = await this.httpApi.get(url, params, { noEnqueue: true });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('approval flow getApprovalList', error);
        throw error;
    }
    async getPreselection(params) {
        const url = this.systemApi.getUrl('getPreselection');
        const res = await this.httpApi.get(url, params);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('approval flow getPreselection', error);
        throw error;
    }
    async updateApprovalStatus(params) {
        const url = this.systemApi.getUrl('updateApprovalStatus');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { success, error } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow updateApprovalStatus', error);
        throw error;
    }
    async deleteApproval(params) {
        const url = this.systemApi.getUrl('deleteApproval');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { success, error } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow deleteApproval', error);
        throw error;
    }
    async approvalDetail(params) {
        const url = this.systemApi.getUrl('approvalDetail');
        const res = await this.httpApi.get(url, params);
        console.log('res: ', res);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('approval flow approvalDetail', error);
        throw error;
    }
    async approvalPriority(params) {
        const url = this.systemApi.getUrl('approvalPriority');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { success, error } = res.data || {};
        if (success) {
            return success;
        }
        console.error('approval flow deleteApproval', error);
        throw error;
    }
    async approvalRecordDetail(params) {
        var _a, _b, _c;
        const url = this.systemApi.getUrl('approvalRecordDetail');
        const res = await this.httpApi.get(url, params, {
            contentType: 'json',
        });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return {
                bizId: data.bizId,
                recordId: (_a = data.logs.recordId) !== null && _a !== void 0 ? _a : '',
                approvalId: (_b = data.logs.approvalId) !== null && _b !== void 0 ? _b : '',
                approvalName: (_c = data.logs.approvalName) !== null && _c !== void 0 ? _c : '',
                status: data.logs.status,
                objectType: data.objectType,
                params: data.params,
                logs: {
                    list: data.logs.content.map(v => ({
                        historyId: v.logId,
                        remark: v.remark,
                        time: v.updateAt,
                        accountInfo: v.accountInfo,
                        status: v.status,
                    })),
                },
            };
        }
        console.error('approval flow approvalRecordDetail', error);
        throw error;
    }
    async approvalRecordPayload(params) {
        const url = this.systemApi.getUrl('approvalRecordPayload');
        const res = await this.httpApi.get(url, params, {
            contentType: 'json',
        });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('approval flow approvalRecordPayload', error);
        throw error;
    }
}
const approvalFlowApiImpl = new ApprovalFlowApiImpl();
api.registerLogicalApi(approvalFlowApiImpl);
export default approvalFlowApiImpl;
